import React from 'react';
import { Link, withPrefix } from 'gatsby';
import slugify from 'slugify';
import _ from 'lodash';

import { TableData, TableRow } from '~components/common/Table';
import { rowRendererProps } from '../propTypes';
import DeadlineRelative from '../../common/DeadlineRelative';
import StateEarlyVotingDate from '../../common/StateEarlyVotingDate';

export default function electionDeadlinesRowRenderer({ state }) {
  const stateName = state.fieldValue;
  const stateSlug = slugify(stateName.toLowerCase());

  const stateData = _.keyBy(state.nodes, 'field_type');

  return (
    <TableRow key={stateSlug}>
      <TableData>
        <a
          href={`/how-to-vote/${stateSlug}/`}
          title={`How to vote in ${stateName}`}
        >
          {stateName}
        </a>
      </TableData>
      <TableData data-title='Voter registration deadlines'>
        <ul>
          <li>
            <strong>In person: </strong>
            <DeadlineRelative
              relativeDeadline={stateData.registration_deadline_in_person}
            />
          </li>
          <li>
            <strong>By mail: </strong>
            <DeadlineRelative
              relativeDeadline={stateData.registration_deadline_mail}
            />
          </li>
          <li>
            <strong>Online: </strong>
            <DeadlineRelative
              relativeDeadline={stateData.registration_deadline_online}
            />
          </li>
          <li>
            <Link
              to={withPrefix(`/register-to-vote/${stateSlug}/`)}
              title={`Register to vote in ${stateName}`}
            >
              Register to vote in {stateName}
            </Link>
          </li>
        </ul>
      </TableData>
      <TableData data-title='Absentee and mail ballot request deadlines'>
        <ul>
          <li>
            <strong>By mail: </strong>
            <DeadlineRelative
              relativeDeadline={stateData.absentee_deadline_mail}
            />
          </li>
          <li>
            <strong>In person: </strong>
            <DeadlineRelative
              relativeDeadline={stateData.absentee_deadline_in_person}
            />
          </li>
          <li>
            <strong>Online: </strong>
            <DeadlineRelative
              relativeDeadline={stateData.absentee_deadline_online}
            />
          </li>
          <li>
            <Link
              to={withPrefix(`/absentee-mail-ballot/${stateSlug}/`)}
              title={`Request your absentee or mail ballot in ${stateName}`}
            >
              Request your absentee or mail ballot in {stateName}
            </Link>
          </li>
        </ul>
      </TableData>
      <TableData data-title='Absentee and mail ballot return deadlines'>
        <ul>
          <li>
            <strong>By mail: </strong>
            <DeadlineRelative
              relativeDeadline={stateData.ballot_return_deadline_mail}
            />
          </li>
          <li>
            <strong>In person: </strong>
            <DeadlineRelative
              relativeDeadline={stateData.ballot_return_deadline_in_person}
            />
          </li>
        </ul>
      </TableData>
      <TableData data-title='Early voting dates'>
        <ul>
          <li>
            <strong>Early voting starts: </strong>
            <StateEarlyVotingDate timePeriod='start' stateData={stateData} />
          </li>
          <li>
            <strong>Early voting ends: </strong>
            <StateEarlyVotingDate timePeriod='end' stateData={stateData} />
          </li>
        </ul>
      </TableData>
    </TableRow>
  );
}

electionDeadlinesRowRenderer.propTypes = rowRendererProps;
